module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_009.png
// module id = 1133
// module chunks = 0